<div class="page" style="display: grid">
    <div class="page_header header">
        <a href="javascript:history.back(-1); void('');" class="container-arrow-left mr-2 " style="max-width: 250px">
            <img src="assets/svg/arrow-left.svg" alt="">
        </a>
        <h1 class="page_title title">Gestão de Ideias <span>Ações</span></h1>
        <div class="page_action">
            <button [disabled]="!urlParams?.id" class="page_action_excel btn btn-warning transfer-button button-disabled" type="button" (click)="convertIdeaToKaizen()">
                <span class="ml-2 font-weight-normal">Converter em ideia Kaizen</span>
            </button>
        </div>
    </div>

    <div class="title-container">
        <h2>{{ideaCode}} <span> | {{ideaTitle ? ideaTitle : 'Nenhuma ideia selecionada'}}</span></h2>

        <button [disabled]="!urlParams?.id" (click)="onOpenModal()" class="page_action_excel btn btn-warning d-flex align-items-center button-disabled" type="button">
            <img src="assets/svg/plus-circle.svg" />
            <span class="ml-2 font-weight-normal">Nova Ação</span>
        </button>
    </div>

    <div class="actions-count">
        <p>Lista de ações <span>{{quantityActionsCompleted}}/{{totalActions}}</span></p>
        <div class="line"></div>
    </div>

    <div class="list-actions custom-scroll">
        <div class="list-actions-items">
            <p *ngIf="!totalActions">Nenhum item encontrado</p>
            <div class="action-item" *ngFor="let action of actions">
                <div class="action-header">
                    <div class="action-status">
                        <span [ngClass]="transformStatusName(action?.status)"></span>
                        <div>
                            <div>
                                <p class="text-normal">status</p>
                                <img (click)="onToggleVisibilityActionStatusModal(action)"
                                    src="assets/svg/arrow-{{action?.isStatusModalVisible ? 'up' : 'down'}}.svg" alt="">

                                <div class="options" *ngIf="action?.isStatusModalVisible">
                                    <ul>
                                        <li (click)="updateActionStatus(action, 'Não Iniciado')">Não iniciado</li>
                                        <li (click)="updateActionStatus(action, 'Em andamento')">Em andamento</li>
                                        <li (click)="updateActionStatus(action, 'Concluido')">Concluido</li>
                                        <li (click)="updateActionStatus(action, 'Cancelado')">Cancelado</li>
                                    </ul>
                                </div>
                            </div>
                            <p class="text-bold">{{translateStatus(action?.status)}}</p>
                        </div>
                    </div>

                    <div class="action">
                        <p class="text-normal">Ação</p>
                        <p class="text-bold">{{action?.title}}</p>
                    </div>

                    <div class="conclusion">
                        <p class="text-normal">Conclusão até</p>
                        <p class="text-bold">{{action?.endDate | date: 'dd/MM/yyyy': 'UTC'}}</p>
                    </div>

                    <div class="manager">
                        <p class="text-normal">Responsável</p>
                        <p class="text-bold">{{action?.responsible?.name}}</p>
                    </div>

                    <div class="actions">
                        <button (click)="onEditAction(action)">
                            <img src="assets/svg/pen.svg" alt="">
                        </button>

                        <a [routerLink]="'/actions-tasks/' + action?.id">
                            <span *ngIf="action?.tasks?.length">{{action?.tasks?.length >= 99 ? '+99' : action?.tasks?.length}}</span>
                            <img src="assets/svg/tasks.svg" alt="">
                        </a>

                        <button (click)="deleteAction(action?.id)">
                            <img src="assets/svg/trash-blue.svg" alt="">
                        </button>

                        <button (click)="onToggleVisibilityActionDescription(action)">
                            <img src="assets/svg/arrow-{{action?.isDescriptionVisible ? 'up' : 'down'}}.svg" alt="">
                        </button>
                    </div>
                </div>
                <div *ngIf="action?.isDescriptionVisible" class="separator"></div>
                <div *ngIf="action?.isDescriptionVisible" class="description">
                    <p class="text-normal">Descrição da Ação</p>
                    <p class="text-bold">{{action?.description}}</p>
                </div>
            </div>
        </div>

    </div>
    <div class="btns">
        <button class="button-disabled" type="button" [disabled]="!totalActions" (click)="updateAllActions()">
            <p>Concluir todas as ações</p>
        </button>
    </div>

    <div id="comments">
        <div class="comments-header">
            <p>Comentários</p>
            <div class="line"></div>
            <button (click)="onToggleVisibilityActionComments()">
                <img src="assets/svg/arrow-{{isCommentVisible ? 'up' : 'down'}}.svg" alt="">
            </button>
        </div>

        <div class="input-box">
            <p>Deixe seu comentário aqui</p>
            <div class="input-container">
                <input type="text" maxlength="250" placeholder="Digite aqui" [(ngModel)]="comment">
                <button (click)="createActionComment()">
                    <img src="assets/svg/verify.svg" alt="">
                </button>

                <div class="input-box">
                    <select id="action" [(ngModel)]="actionId">
                        <option value="">Selecione Ação</option>
                        <option *ngFor="let action of actions" [value]="action.id">{{action.title}}</option>
                    </select>
                </div>
            </div>
            <div class="line"></div>
        </div>

        <div class="comments" *ngIf="isCommentVisible">
            <div class="title-box">
                <p>Comentários</p>
            </div>

            <div class="comment" *ngFor="let comment of comments">
                <div class="header">
                    <p>{{comment?.actionTitle}}</p>
                    <p>{{comment.createdAt | date: 'dd/MM/YYYY': 'UTC'}}</p>
                </div>
                <div class="comment-value">{{comment.comment}}</div>
            </div>
        </div>
    </div>
</div>

<div class="modal-custom modal fade" id="modalAction" data-keyboard="false" data-backdrop="static" role="dialog"
    aria-labelledby="modalNoteResumeLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content p-10">
            <div class="modal-action-header">
                <p> <span>{{ideaCode}}</span> | {{ideaTitle ? ideaTitle : 'Nenhuma ideia selecionada'}}</p>

                <div class="status" *ngIf="this.actionModel.status" [ngClass]="transformStatusName(this.actionModel.status)">
                    <img src="assets/svg/status-{{transformStatusName(this.actionModel.status)}}.svg" alt="icone">
                    <p>{{translateStatus(this.actionModel.status, true)}}</p>
                </div>

            </div>

            <div class="modal-action-body">
                <div class="">
                    <div>
                        <label for="actionTitle">Titulo da Ação*</label>
                        <input type="text" id="actionTitle" placeholder="Digite aqui" maxlength="255"
                            [(ngModel)]="actionModel.title">
                    </div>

                    <p>Ação</p>

                    <div>
                        <label for="actionDescription">Descrição da Ação*</label>
                        <textarea class="description" type="text" id="actionDescription" placeholder="Descrição da ação"
                            maxlength="1000" [(ngModel)]="actionModel.description"></textarea>
                    </div>
                </div>
                <div class="">
                    <div>
                        <label for="actionStatus">Status da Ação</label>
                        <select id="actionStatus" [(ngModel)]="actionModel.status">
                            <option selected value="">Selecione</option>
                            <option value="pending">Não iniciado</option>
                            <option value="in progress">Em andamento</option>
                            <option value="done">Concluido</option>
                            <option value="canceled">Cancelado</option>
                        </select>
                    </div>

                    <div>
                        <label for="actionResponsible">Responsável</label>
                        <select id="actionResponsible" [(ngModel)]="actionModel.responsibleId">
                            <option selected value="">Selecione</option>
                            <option *ngFor="let user of users" [value]="user?.id">{{user?.name}}</option>
                        </select>
                    </div>

                    <div>
                        <label for="actionTitle">Data de Finalização</label>
                        <input type="date" id="actionTitle" [value]="actionModel.endDate" [(ngModel)]="actionModel.endDate">
                    </div>
                </div>
            </div>

            <div class="modal-action-buttons">
                <div class="d-flex flex-grow-1">
                    <a class="btn flex-grow-1 btn-outline-primary" data-dismiss="modal" aria-label="Close">Cancelar</a>
                    <a class="btn flex-grow-1 btn-primary" (click)="onSave()">Salvar</a>
                </div>
            </div>
        </div>
    </div>
</div>